export const CUSTOM_LANDING_PAGE_LOGO_SECTION_CALENDLY_URL =
  'https://calendly.com/themodernbuilder/customer-experience';
export const MARKETPLACE_JOIN_CALENDLY_URL =
  'https://calendly.com/themodernbuilder/join_the_modern_builder_marketplace';
export const LEADFLOW_TALK_TO_SALES_CALENDLY_URL =
  'https://calendly.com/themodernbuilder/discovery';
export const CUSTOM_LANDING_PAGE_STEP1_SECTION_HS_FORM =
  'https://share-eu1.hsforms.com/1EM5-nsmKTW-r_rWp5laEOA2b88ya';
export const CUSTOM_LANDING_PAGE_HERO_SECTION_IFRAME_URL =
  'https://player.vimeo.com/video/964512230?h=61121ffd26&autoplay=1&muted=1';
export const CUSTOM_COST_CALCULATOR_PAGE_COST_CALCULATOR_IFRAME_URL =
  'https://player.vimeo.com/video/1023769962?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';

export const locations = [
  { key: 'east-anglia', label: 'East Anglia' },
  { key: 'london', label: 'London' },
  { key: 'midlands', label: 'Midlands' },
  { key: 'north-england', label: 'North England' },
  { key: 'south-east', label: 'South East' },
  { key: 'south-west', label: 'South West' },
  { key: 'scotland', label: 'Scotland' },
  { key: 'wales', label: 'Wales' },
  { key: 'northern-ireland', label: 'Northern Ireland' },
];

export const epcOptions = [
  { key: 'epc-b', label: 'EPC B' },
  { key: 'epc-a', label: 'EPC A' },
  { key: 'passive-house', label: 'Passive House' },
];

export const qualityOptions = [
  { key: 'basic', label: 'Basic' },
  { key: 'midrange', label: 'Midrange' },
  { key: 'highend', label: 'High-end' },
];

// CustomTrustedSuppliersPage/SectionSuppliers.js
export const metaData = {
  hanley: {
    metaText: 'Hanley Free self build project affordability check Finance/Mortgages',
    metaType: ['Finance/Mortgages'],
    metaRegion: [
      'National',
      'Regional',
      'Scotland',
      'North East',
      'North West',
      'Yorkshire',
      'East Midlands',
      'West Midlands',
      'Greater London',
      'Wales',
      'South East',
      'East of England',
      'South West',
    ],
  },
  mortgageOrg: {
    metaText:
      'Finance/Mortgages For commercial finance advice, including advanced payment for off site construction please contact us',
    metaType: ['Finance/Mortgages'],
    metaRegion: [
      'National',
      'Regional',
      'Scotland',
      'North East',
      'North West',
      'Yorkshire',
      'East Midlands',
      'West Midlands',
      'Greater London',
      'Wales',
      'South East',
      'East of England',
      'South West',
    ],
  },

  joinUsWideBox: {
    metaText: '',
    metaType: [],
    metaRegion: [],
  },

  joinUsSmallBox: {
    metaText: '',
    metaType: [],
    metaRegion: [],
  },

  vatReturn: {
    metaText: 'Finance/Mortgages vat return',
    metaType: ['Finance/Mortgages'],
    metaRegion: [
      'National',
      'Regional',
      'Scotland',
      'North East',
      'North West',
      'Yorkshire',
      'East Midlands',
      'West Midlands',
      'Greater London',
      'Wales',
      'South East',
      'East of England',
      'South West',
    ],
  },
  addland: {
    metaText: `Land Acquisition addland Whether you're seizing the perfect opportunity or researching options for your next project,
      access all the information you need in one place. From flood zones to planning permissions,
      and everything inbetween, Addland delivers instant insights on any registered title. Get 10% off all Property Reports using`,
    metaType: ['Land Acquisition'],
    metaRegion: [
      'National',
      'Regional',
      'Scotland',
      'North East',
      'North West',
      'Yorkshire',
      'East Midlands',
      'West Midlands',
      'Greater London',
      'Wales',
      'South East',
      'East of England',
      'South West',
    ],
  },
  selfBuild: {
    metaText:
      'Insurance/Warranties selfBuild  For self build and commercial insurance <br /> and 10 year structural warranty',
    metaType: ['Insurance/Warranties'],
    metaRegion: [
      'National',
      'Regional',
      'Scotland',
      'North East',
      'North West',
      'Yorkshire',
      'East Midlands',
      'West Midlands',
      'Greater London',
      'Wales',
      'South East',
      'East of England',
      'South West',
    ],
  },
  protek: {
    metaText: 'protek Insurance/Warranties  For self build insurance and warranty get a quote here',
    metaType: ['Insurance/Warranties'],
    metaRegion: [
      'National',
      'Regional',
      'Scotland',
      'North East',
      'North West',
      'Yorkshire',
      'East Midlands',
      'West Midlands',
      'Greater London',
      'Wales',
      'South East',
      'East of England',
      'South West',
    ],
  },
  everhouse: {
    metaText: 'everhouse Windows & Doors Contact here for a quote',
    metaType: ['Windows & Doors'],
    metaRegion: [
      'National',
      'Regional',
      'Scotland',
      'North East',
      'North West',
      'Yorkshire',
      'East Midlands',
      'West Midlands',
      'Greater London',
      'Wales',
      'South East',
      'East of England',
      'South West',
    ],
  },
  tradeShake: {
    metaText: 'Tradeshake helps you get paid on time, every time',
    metaType: ['TradeShake'],
    metaRegion: [],
  },
};

// CustomLandingPage/HeroSecton.js
export const itemsData = [
  {
    title: 'Discover our Trusted Partners',
    description: 'Explore our trusted suppliers dedicated to excellent service.',
    ctaText: 'Discover more',
    ctaLink: '#our_partners',
  },
  {
    title: 'See How Our Clients Succeed',
    description: 'Check out our innovative solutions and dedicated support.',
    ctaText: 'Discover more',
    ctaLink: '/community',
  },
  {
    title: 'Stay Tuned For the Latest Updates',
    description: 'Subscribe to our newsletter for exclusive insights.',
    ctaText: 'Subscribe',
    ctaLink: '/community',
  },
];

export const ENUMS = {
  REACT_APP_STRAPI_BASE_URL: process.env.REACT_APP_STRAPI_BASE_URL,
};

export const DreamHomePageTab = Object.freeze({
  PLOT_DETAILS: 'plot-details',
  DESIGN_BRIEF: 'design-brief',
  FURTHER_REQUIREMENTS: 'further-requirements',
  REVIEW_INFORMATION: 'review-information',
});
export const AnswerOption = {
  YES: 'yes',
  NO: 'no',
};
export const UploadStatus = Object.freeze({
  UPLOADING: 'uploading',
  DONE: 'done',
  ERROR: 'error',
});

export const ReviewFields = {
  PLANNING_PERMISSION_MEDIA: 'planningPermissionMedia',
  MOODBOARD_MEDIA_FILES: 'moodboardMediaFiles',
  PLOT_ADDRESS: 'plotAddress',
  DATE: 'date',
};

export const PlanningPermissionLabel = {
  ID: 'DreamHomePageForm.ProgressSection.planningPermissionLabel',
  DEFAULT: 'Please upload planning permission file',
};
export const MoodboardLabel = {
  ID: 'DreamHomePageForm.ProgressSection.moodboardLabel',
  DEFAULT: 'Please upload moodboard files',
};
export const TransactionProcessAlias = Object.freeze({
  DEFAULT_PURCHASE: 'default-purchase/release-1',
  DEFAULT_INQUIRY: 'default-inquiry/release-1',
  DEFAULT_BOOKING: 'default-booking/release-1',
});

export const UnitType = Object.freeze({
  ITEM: 'item',
  DAY: 'day',
  NIGHT: 'night',
  HOUR: 'hour',
  INQUIRY: 'inquiry',
});

export const StatusCode = Object.freeze({
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
});

export const ListingType = Object.freeze({
  FREE_FLOW: 'free-flow',
});
export const ListingCategory = Object.freeze({
  DREAM_HOME: 'dreamHome',
  HOUSE_BUILDER: 'houseBuilder',
  PROPERTY_DEVELOPER: 'propertyDeveloper',
  SELF_BUILDER: 'selfBuilder',
  OFFSITE_SUPPLIER: 'offsiteSupplier',
  ARCHITECT_PROFESSIONAL: 'architectProfessional',
});

export const PageName = Object.freeze({
  DREAM_HOME_PAGE: 'DreamHomePage',
  PROPERTY_DEVELOPER_PAGE: 'PropertyDeveloperPage',
});

export const CostEstimationHeader = Object.freeze({
  SUPPLIER_ONE: 'supplier1',
  SUPPLIER_TWO: 'supplier2',
  SUPPLIER_THREE: 'supplier3',
  CRITERIA: 'criteria',
});

export const UserType = Object.freeze({
  ARCHITECT_PROFESSIONAL: 'architectProfessional',
  OFFSITE_SUPPLIER: 'offsiteSupplier',
  SELF_BUILDER: 'selfBuilder',
  PROPERTY_DEVELOPER: 'propertyDeveloper',
});

export const ProfileSettingsFormKeys = Object.freeze({
  SURPRISE_ME: 'surprise-me',
  OTHER: 'other',
});

export const StrapiUserTypePages = Object.freeze({
  DEVELOPER_LANDING_PAGE: 'Developer Landing Page',
  CUSTOMER_LANDING_PAGE: 'Customer Landing Page',
  FAQ_MAIN_PAGE: 'FAQ Main Page',
});

export const FLOATING_TOPBAR = 'floating';

export const RedirectType = Object.freeze({
  NAMED: 'named',
  URL: 'redirect',
});

export const STRAPI_USER_TYPE = Object.freeze({
  CUSTOMER: 'customer',
  SUPPLIER: 'supplier',
});

export const StringBoolean = Object.freeze({
  TRUE: 'true',
  FALSE: 'false',
});

export const userTypeOptions = [
  {
    value: '',
    labelId: 'SignupForm.selectOption',
    disabled: true,
    hidden: true,
  },
  {
    value: 'selfBuilder',
    labelId: 'SignupForm.userType.selfBuilder',
  },
  {
    value: 'propertyDeveloper',
    labelId: 'SignupForm.userType.propertyDeveloper',
  },
  {
    value: 'offsiteSupplier',
    labelId: 'SignupForm.userType.offsiteSupplier',
  },
  {
    value: 'architectProfessional',
    labelId: 'SignupForm.userType.architectProfessional',
  },
];

// Supplier-specific user type options for /signup-supplier page
export const supplierUserTypeOptions = [
  {
    value: '',
    labelId: 'SignupForm.selectOption',
    disabled: true,
    hidden: true,
  },
  {
    value: 'offsiteSupplier',
    labelId: 'SignupForm.userType.supplierOffsiteSupplier',
  },
  {
    value: 'builder',
    labelId: 'SignupForm.userType.supplierBuilder',
  },
  {
    value: 'architect',
    labelId: 'SignupForm.userType.supplierArchitect',
  },
  {
    value: 'professionalServices',
    labelId: 'SignupForm.userType.supplierProfessionalServices',
  },
];

// Customer-specific user type options for /signup-customer page
export const customerUserTypeOptions = [
  {
    value: '',
    labelId: 'SignupForm.selectOption',
    disabled: true,
    hidden: true,
  },
  {
    value: 'selfBuilder',
    labelId: 'SignupForm.userType.customerSelfBuilder',
  },
  {
    value: 'propertyDeveloper',
    labelId: 'SignupForm.userType.customerPropertyDeveloper',
  },
];

export const SUPPLIER_TYPE_ORDER = [
  'finance-mortgages',
  'land-acquisition',
  'insurance-warranties',
  'trade-merchant-accounts',
  'structural-engineers',
  'site-investigation',
  'groundworkers',
  'interior-designers',
  'renewable-energy',
  'electricians',
  'plumbers',
  'kitchens',
  'windows-and-doors',
  'bathrooms',
  'fitted-furniture',
  'other-suppliers',
  'contracts',
];

export const GEOGRAPHICAL_COVERAGE_ORDER = [
  'national',
  'regional',
  'scotland',
  'north-east',
  'north-west',
  'yorkshire',
  'east-midlands',
  'west-midlands',
  'greater-london',
  'wales',
  'south-east',
  'east-of-england',
  'south-west',
];

export const ReviewAction = Object.freeze({
  ACCEPT: 'accept',
  REJECT: 'reject',
});

export const Pathname = Object.freeze({
  REVIEW_BRIEF: 'review-brief',
  ADMIN_REVIEW: 'admin-review',
});

export const MediaTypes = Object.freeze({
  MOODBOARD: 'moodboardMediaFiles',
  PLANNING_PERMISSION: 'planningPermissionMedia',
});

export const AdminReviewFormTranslationId = {
  TITLE: 'AdminDreamListingReviewForm.sendInfo.title',
  DESCRIPTION: 'AdminDreamListingReviewForm.sendInfo.description',
  ACCEPT_BUTTON: 'AdminDreamListingReviewForm.sendInfo.acceptButton',
  REMIND_BUTTON: 'AdminDreamListingReviewForm.sendInfo.remindButton',
  REJECT_BUTTON: 'AdminDreamListingReviewForm.sendInfo.rejectButton',
};

export const ExpandableStageFields = {
  KITCHEN_FIXTURES: 'kitchenFixturesFittings',
  ADDITIONAL_BATHROOMS: 'addAdditionalBathrooms',
};

export const ExpandableStageFieldList = [
  ExpandableStageFields.KITCHEN_FIXTURES,
  ExpandableStageFields.ADDITIONAL_BATHROOMS,
];

export const ValueType = Object.freeze({
  STRING: 'string',
});
